var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "participant-header-column field-col" }, [
    _c("div", { staticClass: "content", on: { click: _vm.handleClick } }, [
      _c("div", { staticClass: "caption-text" }, [
        _vm._v(_vm._s(_vm.headerObject.displayName))
      ]),
      _vm._v(" "),
      _vm.showIcon
        ? _c("div", { staticClass: "icon-sort", class: [_vm.getIconClassName] })
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8bd26b18", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8bd26b18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/commons/HeaderColumn.vue
// module id = 1720
// module chunks = 1